import { addMicrosoftAdvertisingEvent } from '@shared/analytics/events'
import type { MicrosoftAdvertisingPlugin } from '@shared/analytics/types/microsoft-advertising'

export const microsoftAdvertising: MicrosoftAdvertisingPlugin = {
  init: () => {
    addMicrosoftAdvertisingEvent()
  },
}
